import { WSContainer } from "@wingspanhq/fe-component-library";
import { FreelanceType } from "@wingspanhq/users/dist/lib/interfaces";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../query/hooks/helpers";
import { useUserLocation } from "../../query/user";
import {
  useUpdateActivity,
  useUpdateMemberProfile
} from "../../query/users/mutations";
import { useMemberProfile } from "../../query/users/queries";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { OnboardingQuestion } from "../components/OnboardingQuestion/OnboardingQuestion";

interface OnboardingStep1Props {}

export const OnboardingStep1: React.FC<OnboardingStep1Props> = () => {
  const history = useHistory();
  const userId = useUserId();
  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId);
  const qMember = useMemberProfile(userId);
  const userLocationQuery = useUserLocation();
  const [
    updateMemberProfile,
    updateMemberProfileMeta
  ] = useUpdateMemberProfile();
  React.useEffect(() => {
    updateActivity({
      flows: {
        onboarding: {
          version: 3,
          currentStep: 1,
          totalSteps: 4,
          complete: false
        }
      }
    });
  }, []);

  const onBack =
    userLocationQuery.data?.isoCode !== "US"
      ? () => {
          history.push("/member/onboarding/block");
        }
      : undefined;

  const onSubmit = async (data: any) => {
    await updateMemberProfile({
      memberId: qMember.data?.memberId as string,
      profile: {
        freelanceType: data.freelanceType
      }
    });
    await updateActivity({
      flows: {
        onboarding: {
          version: 3,
          currentStep: 2,
          totalSteps: 4,
          complete: false
        }
      }
    });
    history.push("/member/onboarding/step/2");
  };
  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 1" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        <OnboardingQuestion
          name="freelanceType"
          question={{
            question: "What type of freelancer are you?",
            options: [
              {
                label: "Studio/Team of Freelancers",
                value: FreelanceType.Team,
                virtualAssistantMsg:
                  "Well let’s get on the same team then! Wingspan helps you take care of your people and coordinate with subcontractors.",
                ctaBtnText: "See how Wingspan works for you"
              },
              {
                label: "Full-time 1099",
                value: FreelanceType.FullTime,
                virtualAssistantMsg:
                  "Get it! Wingspan has everything you need to work for yourself and feel in control.",
                ctaBtnText: "See how Wingspan works for you"
              },
              {
                label: "Part-time 1099",
                value: FreelanceType.PartTime,
                virtualAssistantMsg:
                  "Someone's skills are in demand! We know how much you're juggling. We're here to put the admin stuff on cruise control.",
                ctaBtnText: "See how Wingspan works for you"
              },
              {
                label: "Not freelancing currently",
                value: FreelanceType.NotFreelancing,
                virtualAssistantMsg:
                  "Well, freelancing isn't for everybody. But if you're not freelancing, Wingspan isn't for you. How about a blind date with a website?",
                ctaBtnText: "Take me to a random website"
              }
            ]
          }}
          onSubmit={onSubmit}
          isSubmitting={
            updateMemberProfileMeta.isLoading || updateActivityMeta.isLoading
          }
          defaultValues={{
            freelanceType: qMember.data?.profile.freelanceType
          }}
        />
      </WSContainer>
    </>
  );
};
